import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";

const STEPS = [
    { num: "01", title: "Share Your Details", text: "Provide your name, date of birth — or a handwriting & signature sample." },
    { num: "02", title: "Get Your Analysis", text: "Your numbers and handwriting are carefully studied by Maitrii herself." },
    { num: "03", title: "Understand Yourself", text: "Receive personalized insights through a consultation and detailed report." },
];

export const HowItWorks = () => {
    return (
        <section id="how-it-works" data-testid="how-it-works-section" className="py-28 lg:py-36 px-6 relative">
            <div className="max-w-6xl mx-auto">
                <Reveal className="text-center max-w-2xl mx-auto">
                    <Overline>How It Works</Overline>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#F0EBE0]">
                        Three steps to <span className="italic text-[#C9A962]">clarity</span>
                    </h2>
                </Reveal>

                <div className="mt-20 relative">
                    <svg className="hidden md:block absolute top-10 left-[16%] right-[16%] w-[68%] h-2" preserveAspectRatio="none" viewBox="0 0 100 2">
                        <motion.line
                            x1="0" y1="1" x2="100" y2="1"
                            stroke="#C9A962" strokeWidth="0.4" strokeDasharray="2 1.5"
                            initial={{ pathLength: 0 }}
                            whileInView={{ pathLength: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 2, ease: "easeInOut" }}
                        />
                    </svg>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
                        {STEPS.map((s, i) => (
                            <Reveal key={s.num} delay={i * 0.2} className="relative text-center md:text-left">
                                <div className="flex md:block items-center justify-center">
                                    <div className="w-20 h-20 rounded-full border border-[#C9A962]/40 bg-[#081226] flex items-center justify-center relative z-10 mx-auto md:mx-0 shadow-[0_0_30px_rgba(201,169,98,0.15)]">
                                        <span className="font-mono-num text-xl text-[#C9A962]">{s.num}</span>
                                    </div>
                                </div>
                                <h3 className="mt-6 font-display text-xl lg:text-2xl font-semibold text-[#F0EBE0]">{s.title}</h3>
                                <p className="mt-3 text-sm font-light text-[#A19D94] leading-relaxed max-w-xs mx-auto md:mx-0">{s.text}</p>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
